const WINKER_SERVICE_AGENT_EMAIL =
  /^(admin|integracao)\+[^@]+@winker\.com\.br$/i;

export const isWinkerServiceAgent = email =>
  WINKER_SERVICE_AGENT_EMAIL.test(email || '');

// Mirrors Channel::WhatsappTest::MANAGER_EMAIL_FORMAT: only the `admin+` service account
// creates the WhatsApp test inbox (the `integracao+` user is an integration, not who deploys).
const WHATSAPP_TEST_MANAGER_EMAIL = /^admin\+[^@\s]+@winker\.com\.br$/i;

export const isWhatsappTestManager = email =>
  WHATSAPP_TEST_MANAGER_EMAIL.test(email || '');
